// @flow
import React, { type ComponentType } from 'react';

import cx from 'classnames';
import styles from './FlatfyLogo.module.scss';

import flatfyLogoBlack from './assets/logo-black.png';
import flatfyLogoBlack2x from './assets/logo-black@2x.png';
import flatfyLogoBlack3x from './assets/logo-black@3x.png';

import flatfyLogoBlackVector from './assets/logo-black.svg';

import flatfyLogoWhite from './assets/logo-white.png';
import flatfyLogoWhite2x from './assets/logo-white@2x.png';
import flatfyLogoWhite3x from './assets/logo-white@3x.png';

import flatfyLogoWhiteVector from './assets/logo-white.svg';

type Theme = 'dark' | 'light';

type FlatfyLogoProps = {
  theme: Theme,
};

const FlatfyLogo: ComponentType<FlatfyLogoProps> = ({ theme = 'light' }) => {
  const caption = 'Flatfy logotype';

  return (
    <>
      <picture className={cx(styles.root, { [styles.root_current]: theme === 'dark' })}>
        <source type="image/svg+xml" srcSet={flatfyLogoWhiteVector} />
        <img
          src={flatfyLogoWhite}
          srcSet={`${flatfyLogoWhite2x} 2x, ${flatfyLogoWhite3x} 3x`}
          alt={caption}
        />
      </picture>
      <picture className={cx(styles.root, { [styles.root_current]: theme === 'light' })}>
        <source type="image/svg+xml" srcSet={flatfyLogoBlackVector} />
        <img
          src={flatfyLogoBlack}
          srcSet={`${flatfyLogoBlack2x} 2x, ${flatfyLogoBlack3x} 3x`}
          alt={caption}
        />
      </picture>
    </>
  );
};

export default FlatfyLogo;
